import { CanDeactivateFn } from '@angular/router';
import type { WorkflowWorkspaceComponent } from './workflow-workspace.component';

export const workflowWorkspaceNavigationGuard: CanDeactivateFn<
  WorkflowWorkspaceComponent
> = (component) => component.confirmNavigation();
